import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

import { isAgent } from '../../../../lib/flow/pageHelpers';

export const isEnabled: FlowPage['isEnabled'] = ({ answers, inputContext: { channel } }) =>
  isAgent(answers, channel);

const agentVerificationPage: FlowPage = {
  slug: () => 'agent-verification',
  title: () => "Let's verify your agent info",
  isEnabled,
  autoAdvance: () => false,
  questions: ({ answers, inputContext: { channel } }): FlowQuestion[] => [
    {
      key: 'seller.mls_agent_id',
      label: 'MLS ID',
      type: 'single_line',
      hidden: !isAgent(answers, channel),
      placeholder: 'Example MLS ID',
    },
    {
      key: 'seller.mls_name',
      label: 'MLS Name',
      type: 'combo_input',
      hidden: !isAgent(answers, channel),
      placeholder: 'Select...',
      optional: true,
      optionsDataSource: 'mls_names',
    },
    {
      key: 'seller.brokerage',
      label: 'Brokerage name (optional)',
      type: 'single_line',
      hidden: !isAgent(answers, channel),
      placeholder: 'Your brokerage name',
      optional: true,
    },
  ],
};

export default agentVerificationPage;
